function Clone({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '20'} height=${(dimensions / 20) * 22 || '22'} viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.5 0H2.5C1.4 0 0.5 0.9 0.5 2V16H2.5V2H14.5V0ZM17.5 4H6.5C5.4 4 4.5 4.9 4.5 6V20C4.5 21.1 5.4 22 6.5 22H17.5C18.6 22 19.5 21.1 19.5 20V6C19.5 4.9 18.6 4 17.5 4ZM17.5 20H6.5V6H17.5V20Z" fill=${`"${col}"`} />
    </svg>
  `;

  return baseXml;
}

export default Clone;
